<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">確認コードの入力</p>
        <button @click="cancel" class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label for="device-name">確認コード</label>
          <div class="control">
            <input v-model="code" class="input" name="confirmation-code" type="text">
          </div>
        </div>
        <p>5分経過しても確認コードが受信されない場合、メールアドレスの重複や間違いの可能性があります。メールアドレスを確認してもう一度登録を開始してください。</p>
      </section>
      <footer class="modal-card-foot">
        <button @click="submit" class="button is-primary">送信</button>
        <button @click="cancel" class="button">キャンセル</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { Authentication } from '@/components/Authentication';

export default {
  props: [
    'username',
  ],
  data: function() {
    return {
      code: '',
    }
  },
  methods: {
    initParams: function() {
      this.code = '';
    },
    submit: function() {
      Authentication.confirmSignUp(this.username, this.code).then(
        () => {
          this.initParams();
          this.$emit('confirmation-finish');
        }
      ).catch(
        (err) => {
          if (err.code === 'CodeMismatchException') {
            alert('確認コードが違います。再送した確認コードを入力してください。');
            this.initParams();
            Authentication.resendSignUp(this.username, this.code);
          }
        }
      );
    },
    cancel: function() {
      this.initParams();
      this.$emit('cancel');
    },
  }
}
</script>